type SqlDateInput = Date | string | number;

export function dateToSqlValue(value: SqlDateInput): string {
  return value instanceof Date ? value.toISOString() : new Date(value).toISOString();
}

export function nullableDateToSqlValue(value: SqlDateInput | null | undefined): string | null {
  return value ? dateToSqlValue(value) : null;
}

export function jsonToSqlValue(value: unknown): string | null {
  return value ? JSON.stringify(value) : null;
}

export function booleanToSqlValue(value: boolean): 1 | 0 {
  return value ? 1 : 0;
}
